import { useEffect, useState } from "react";
import "./WazToolbar.css";
import { AppWindow, Bell, Home, MessagesSquare, Plus, Ticket } from "lucide-react";
import { AppSidebar } from "../../app/sidebar/AppSidebar";
import { useNavigate } from "react-router-dom";
import { set } from "lodash";
import { useSelector } from "react-redux";
import { APP_MENUS, selectUIStates } from "../../../redux/features/appData";

const TOOLS = {
    HOME: "home",
    NEW: "new",
    CONVERSATIONS: "conversations",
    TICKET: "ticket",
    NOTIFICATIONS: "notifications",
    APP: "app",
}

type WazToolbarProps = {
    viewingApp?: boolean;
}

export const WazToolbar = ({viewingApp = false }: WazToolbarProps) => {

    const navigate = useNavigate();
    const uiStates = useSelector(selectUIStates);

    const [selectedTool, setSelectedTool] = useState<string>(TOOLS.HOME);
    const [isExpanded, setIsExpanded] = useState<boolean>(viewingApp);

    console.log("[WazToolbar] selectedTool: ", selectedTool);

    return (
        <>
           
            <div className="waz-toolbar">
                <div 
                    className={selectedTool === TOOLS.HOME ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        setSelectedTool(TOOLS.HOME)
                        navigate("/waz");
                    }}
                >
                    <Home size={16} />
                </div>
                
                <div 
                    className={selectedTool === TOOLS.NEW ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => setSelectedTool(TOOLS.NEW)}
                >
                    <Plus size={16} />
                </div>

                <div 
                    className={selectedTool === TOOLS.CONVERSATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        setSelectedTool(TOOLS.CONVERSATIONS)
                        setIsExpanded(!isExpanded)
                    }}
                >
                    <MessagesSquare size={16} />
                </div>

                <div 
                    className={selectedTool === TOOLS.TICKET ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => setSelectedTool(TOOLS.TICKET)}
                >
                    <Ticket size={16} />
                </div>
                <div 
                    className={selectedTool === TOOLS.NOTIFICATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => setSelectedTool(TOOLS.NOTIFICATIONS)}
                >
                    <Bell size={16} />
                </div>

                <div 
                    className="waz-toolbar-login"
                    onClick={() => {
                        setSelectedTool(TOOLS.APP)
                        setIsExpanded(!isExpanded)

                        if (isExpanded) {      // go back to waz
                            navigate("/waz");
                        } else 
                        {
                            navigate("/app");
                        }
                        
                    }}
                >
                    <AppWindow size={16} color={isExpanded ? "red" : "black"} />
                </div>
                <div className="waz-toolbar-avatar">
                    <img src="https://s3.eu-central-1.amazonaws.com/xmp-hmn-objects/1bf1bebf80e8c0342c95edd1e6f878024430e22f22af17cd6f1a225761c027c9" />
                </div>
            </div>
            
            {/* {isExpanded &&
                <div className="waz-toolbar-expanded">
                    <div className="waz-toolbar-expanded-menu">
                        <div 
                            className={selectedTool === TOOLS.HOME ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.HOME)}
                        >
                            <Home size={16} />
                            
                        </div>
                        <span>Home</span>
                    </div>
                    
                    <div className="waz-toolbar-expanded-menu">
                        <div 
                            className={selectedTool === TOOLS.NEW ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.NEW)}
                        >
                            <Plus size={16} />
                        </div>
                        <span>New Conversation</span>
                    </div>

                    <div className="waz-toolbar-expanded-menu">

                        <div 
                            className={selectedTool === TOOLS.CONVERSATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => {
                                setSelectedTool(TOOLS.CONVERSATIONS)
                                setIsExpanded(!isExpanded)
                            }}
                        >
                            <MessagesSquare size={16} /> 
                        </div>
                        <span>Conversations</span>
                    </div>

                    <div className="waz-toolbar-expanded-menu">

                        <div 
                            className={selectedTool === TOOLS.TICKET ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.TICKET)}
                        >
                            <Ticket size={16} /> 
                            
                        </div>
                        <span>Tickets</span>
                    </div>

                    <div className="waz-toolbar-expanded-menu">
                        <div 
                            className={selectedTool === TOOLS.NOTIFICATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.NOTIFICATIONS)}
                        >
                            <Bell size={16} />
                            
                        </div>
                        <span>Notifications</span>
                    </div>

                    <div className="waz-toolbar-login">
                        <div className="waz-toolbar-expanded-menu">
                            <AppWindow size={16} />
                            <span>Login</span>
                        </div>
                    </div>
                    <div className="waz-toolbar-avatar">
                        <div className="waz-toolbar-expanded-menu">
                            <img src="https://s3.eu-central-1.amazonaws.com/xmp-hmn-objects/1bf1bebf80e8c0342c95edd1e6f878024430e22f22af17cd6f1a225761c027c9" />
                            <span>Your Name</span>
                        </div>
                    </div>
                </div>
            } */}

            {/* {isExpanded && selectedTool === TOOLS.APP &&
                <AppSidebar />
            } */}
        </>
    )
}